import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import TextEditor from "../../Components/TextEditor/TextEditor";
import { useUpdatePageMutation } from "../../Data/services/pageApi";
import Toast from "../../Hooks/useToast";
import styles from "./styles/StaticPage.module.scss";
import LoadingButton from "../../Components/CustomComponents/LoadingButton";

//

export default function TermsAndConditions({ data, isLoading, refetch }) {
  const { handleSubmit, control, register, errors, setValue } = useForm({
    mode: "onChange",
  });
  const [updatePage, { isLoading: isLoadingUpdate }] = useUpdatePageMutation();
  const [link, setLink] = useState("");

  const handleLinkChange = (e) => {
    console.log(e.target.value);
    setLink(e.target.value);
  };

  const handleSaveText = () => {
    // console.log(value)
    // console.log(value);
  };

  useEffect(() => {
    setValue("url", data?.data?.url);
    setValue("title", data?.data?.title);
    setValue("content", data?.data?.content);
  }, [data, refetch]);

  const onUpdateSubmit = async (data) => {
    try {
      let response = await updatePage({ id: 2, modifiedData: data }).unwrap();
      refetch();
      Toast(response?.message, "success");
    } catch (error) {
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={styles.StaticPage}>
      <Form onSubmit={handleSubmit(onUpdateSubmit)}>
        <Row>
          <Col sm={10}>
            <SubTitle
              text="Terms And Condition"
              classes="mb-4 primary-text text-white"
            />
            <label className="fs-6 fw-bold text-white">URL</label>
            <Controller
              control={control}
              name="url"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Input
                  name="url"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            <label className="fs-6 fw-bold text-white">Title</label>
            <Controller
              control={control}
              name="title"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Input
                  name="title"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Col>
          <Col sm={2}>
            <Button
              classes={`${styles.cardBtn} `}
              text={isLoading ? <LoadingButton /> : "Save"}
              type="submit"
              disabled={isLoadingUpdate}
            ></Button>
          </Col>
        </Row>
      </Form>

      <label className="fs-6 fw-bold text-white">Content</label>
      <Controller
        control={control}
        name="content"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <TextEditor text={value} onChange={onChange} />
        )}
      />
    </div>
  );
}
